import React, { useState, useEffect } from 'react'
import { colors } from 'Constants'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

import { Grid } from 'lese'
import { SectionHeaderSort } from 'Components/Section'
import { sortMethods } from 'Helpers'

import GridHeader from 'Components/Grid/GridHeader'

const setReportSortingStore = (id, props) =>
  ReportSortingStore.set(state => ({ [id]: { ...state[id], ...props } }))

const getSortMethodName = func =>
  Object.entries(sortMethods).find(sortMethod => sortMethod[1] === func)[0]

export default ({ report, columns, ReportRow, defaultSortIndex, prop }) => {
  const id = report.officeId
  const reportSortingState = useStore(ReportSortingStore)

  useEffect(
    () =>
      setReportSortingStore(id, {
        reversed: false,
        sortIndex: defaultSortIndex,
        property: columns[defaultSortIndex].property,
        sortMethod: getSortMethodName(
          columns[defaultSortIndex].sort || sortMethods.alphabetical
        )
      }),
    []
  )

  const sortSelection = reportSortingState[id]?.sortIndex
  const isReversed = reportSortingState[id]?.reversed

  const [sortedReport, setSortedReport] = useState(() => {
    const sortFunc = columns[defaultSortIndex].sort || sortMethods.alphabetical
    const sortProperty = columns[defaultSortIndex].property

    return report[prop].sort((a, b) =>
      sortFunc(a[sortProperty], b[sortProperty])
    )
  })

  const createSort = (i, property, sort = sortMethods.alphabetical) => () => {
    if (isReversed && i === sortSelection) {
      setReportSortingStore(id, { reversed: false })
      setSortedReport(sortedReport.reverse())
      return
    }
    if (i === sortSelection) {
      setReportSortingStore(id, { reversed: true })
      setSortedReport(sortedReport.reverse())
      return
    }

    setReportSortingStore(id, {
      reversed: false,
      method: getSortMethodName(sort),
      property,
      sortIndex: i
    })

    let newSortedReport = sortedReport.sort((a, b) =>
      sort(a[property], b[property])
    )
    if (isReversed) newSortedReport = newSortedReport.reverse()

    setSortedReport(newSortedReport)
  }

  if (sortedReport.length === 0)
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '16px 0',
          margin: '16px 0',
          borderBottom: `1px solid ${colors.borderColor}`
        }}
      >
        There are no items in this office
      </div>
    )

  return (
    <>
      <Grid
        columns={
          columns.map(val => val.size?.split('x')[0] || '1').join('fr ') + 'fr'
        }
      >
        <GridHeader>
          {columns.map((headerInfo, i) => (
            <SectionHeaderSort
              selected={sortSelection === i}
              reversed={isReversed}
              onClick={createSort(i, headerInfo.property, headerInfo.sort)}
            >
              {headerInfo.header}
            </SectionHeaderSort>
          ))}
        </GridHeader>

        {sortedReport
          .map(row => {
            const columnsWithFormatting = columns.filter(
              a => typeof a.format === 'function'
            )
            for (const column of columnsWithFormatting)
              row[column.property] = column.format(row[column.property])
            return row
          })
          .map(row => (
            <ReportRow row={row} key={row.id} />
          ))}
      </Grid>
    </>
  )
}
